import axios from 'axios';
import {
  GET_SYSTEM_COUPONS_REQUEST,
  GET_SYSTEM_COUPONS_SUCCESS,
  GET_SYSTEM_COUPONS_FAILURE,
  RESET_SYSTEM_COUPONS,
  GET_CONTINUED_COUPONS_REQUEST,
  GET_CONTINUED_COUPONS_SUCCESS,
  GET_CONTINUED_COUPONS_FAILURE,
  RESET_CONTINUED_COUPONS_PAGINATION,
  GET_WON_COUPONS_REQUEST,
  GET_WON_COUPONS_SUCCESS,
  GET_WON_COUPONS_FAILURE,
  RESET_WON_COUPONS_PAGINATION,
  GET_LOST_COUPONS_REQUEST,
  GET_LOST_COUPONS_SUCCESS,
  GET_LOST_COUPONS_FAILURE,
  RESET_LOST_COUPONS_PAGINATION,
  GET_SAVED_COUPONS_REQUEST,
  GET_SAVED_COUPONS_SUCCESS,
  GET_SAVED_COUPONS_FAILURE,
  RESET_SAVED_COUPONS_PAGINATION,
  GET_TRIBUN_COUPONS_REQUEST,
  GET_TRIBUN_COUPONS_SUCCESS,
  GET_TRIBUN_COUPONS_FAILURE,
  RESET_TRIBUN_COUPONS_PAGINATION,
  GET_COUPON_DETAIL_REQUEST,
  GET_COUPON_DETAIL_SUCCESS,
  GET_COUPON_DETAIL_FAILURE,
  DELETE_COUPON_BY_ID_REQUEST,
  DELETE_COUPON_BY_ID_SUCCESS,
  DELETE_COUPON_BY_ID_FAILURE,
  GET_OUT_RIGHT_CONTINUE_COUPONS_REQUEST,
  GET_OUT_RIGHT_CONTINUE_COUPONS_SUCCESS,
  GET_OUT_RIGHT_CONTINUE_COUPONS_FAILURE,
  GET_OUT_RIGHT_WON_COUPONS_REQUEST,
  GET_OUT_RIGHT_WON_COUPONS_SUCCESS,
  GET_OUT_RIGHT_WON_COUPONS_FAILURE,
  GET_OUT_RIGHT_LOST_COUPONS_REQUEST,
  GET_OUT_RIGHT_LOST_COUPONS_SUCCESS,
  GET_OUT_RIGHT_LOST_COUPONS_FAILURE,
  GET_OUT_RIGHT_SAVED_COUPONS_REQUEST,
  GET_OUT_RIGHT_SAVED_COUPONS_SUCCESS,
  GET_OUT_RIGHT_SAVED_COUPONS_FAILURE,
  DELETE_SAVED_COUPON_BY_ID_REQUEST,
  DELETE_SAVED_COUPON_BY_ID_SUCCESS,
  DELETE_SAVED_COUPON_BY_ID_FAILURE,
  RESET_OUT_RIGHT_CONTINUE_PAGINATION,
  RESET_OUT_RIGHT_WON_PAGINATION,
  RESET_OUT_RIGHT_LOST_PAGINATION,
  RESET_OUT_RIGHT_SAVED_PAGINATION,
  GET_REJECTED_COUPONS_REQUEST,
  GET_REJECTED_COUPONS_SUCCESS,
  GET_REJECTED_COUPONS_FAILURE,
  RESET_REJECTED_COUPONS_PAGINATION,
  GET_EVENT_STATUS_UPDATE_REQUEST,
  GET_EVENT_STATUS_UPDATE_SUCCESS,
  GET_EVENT_STATUS_UPDATE_FAILURE,
  SET_COUPONS_ACTIVE_FILTER,
  EVENT_SCORES_SUCCESS,
  CONTINUED_COUPONS_REQUEST_ADDITIONAL_TIME,
  GET_IDDAA_COUPON_INFO_REQUEST,
  GET_IDDAA_COUPON_INFO_SUCCESS,
  GET_IDDAA_COUPON_INFO_FAILURE,
  GET_TJK_COUPON_INFO_REQUEST,
  GET_TJK_COUPON_INFO_SUCCESS,
  GET_TJK_COUPON_INFO_FAILURE,
  GET_COUPON_CHANGE_ODDS_REQUEST,
  GET_COUPON_CHANGE_ODDS_SUCCESS,
  GET_COUPON_CHANGE_ODDS_FAILURE
} from 'Store/constants';
import errorMessage from 'Store/actions/errorMessage';
import { COUPONS_FILTERS } from 'Store/constants/sportTypes';
import { closeModal, openModal, updateUserBalance, getEventScores } from 'Store/actions';
import { TIME_LAST_7_DAYS, TIME_LAST_15_DAYS, TIME_LAST_1_MONTH, TIME_LAST_3_MONTHS, TIME_LAST_6_MONTHS, TIME_LAST_1_YEAR, TIME_ALL } from 'Utils/timeConstants';
import EnvironmentManager from 'Utils/environmentManager';
import flatten from 'lodash/flatten';

const couponOptions = {
  sortFieldName: 'createdDate',
  endDate: 0,
  startDate: 1,
  couponStatuses: [],
  ascending: false,
};

const getFilterDates = filterName => {
  let startDate = TIME_ALL;
  const endDate = new Date().getTime();


  switch (filterName) {
    case COUPONS_FILTERS.LAST_7_DAYS:
      startDate = TIME_LAST_7_DAYS;
      break;
    case COUPONS_FILTERS.LAST_15_DAYS:
      startDate = TIME_LAST_15_DAYS;
      break;
    case COUPONS_FILTERS.LAST_1_MONTH:
      startDate = TIME_LAST_1_MONTH;
      break;
    case COUPONS_FILTERS.LAST_3_MONTHS:
      startDate = TIME_LAST_3_MONTHS;
      break;
    case COUPONS_FILTERS.LAST_6_MONTHS:
      startDate = TIME_LAST_6_MONTHS;
      break;
    case COUPONS_FILTERS.LAST_1_YEAR:
      startDate = TIME_LAST_1_YEAR;
      break;
    case COUPONS_FILTERS.ALL:
      startDate = TIME_ALL;
      break;
    default:
      break;
  }

  return { startDate, endDate };
};

export const resetCouponPagination = couponType => async dispatch => {
  switch (couponType) {
    case 'CONTINUED':
      dispatch({
        type: RESET_CONTINUED_COUPONS_PAGINATION
      });
      break;
    case 'WON':
      dispatch({
        type: RESET_WON_COUPONS_PAGINATION
      });
      break;
    case 'LOST':
      dispatch({
        type: RESET_LOST_COUPONS_PAGINATION
      });
      break;
    case 'SAVED':
      dispatch({
        type: RESET_SAVED_COUPONS_PAGINATION
      });
      break;
    case 'TRIBUN':
      dispatch({
        type: RESET_TRIBUN_COUPONS_PAGINATION
      });
      break;
    case 'OUTRIGHT_CONTINUED':
      dispatch({
        type: RESET_OUT_RIGHT_CONTINUE_PAGINATION
      });
      break;
    case 'OUTRIGHT_WON':
      dispatch({
        type: RESET_OUT_RIGHT_WON_PAGINATION
      });
      break;
    case 'OUTRIGHT_LOST':
      dispatch({
        type: RESET_OUT_RIGHT_LOST_PAGINATION
      });
      break;
    case 'OUTRIGHT_SAVED':
      dispatch({
        type: RESET_OUT_RIGHT_SAVED_PAGINATION
      });
      break;
    case 'REJECTED':
      dispatch({
        type: RESET_REJECTED_COUPONS_PAGINATION
      });
  }
};

export const getSystemCoupons = couponId => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_SYSTEM_COUPONS_REQUEST
    });

    const res = await (
      couponId ? axios({
        url: `/iddaa/system/combinations/${couponId}`,
        method: 'GET'
      }) : axios({
        url: '/iddaa/system/combinations',
        method: 'POST',
        data: getState().betSlip.coupon
      })
    );

    dispatch({
      type: GET_SYSTEM_COUPONS_SUCCESS,
      payload: res.data.combinations
    });

    if (couponId) {
      const uniqueEventsMap = new Map();
      res.data.combinations.forEach(combination => {
        combination.bets.forEach(bet => {
          if (!uniqueEventsMap.has(bet.eventId)) {
            uniqueEventsMap.set(bet.eventId, bet);
          }
        });
      });

      dispatch(getEventStatusUpdate([{ selections: [...uniqueEventsMap.values()] }]));
    }

  } catch (e) {
    dispatch({
      type: GET_SYSTEM_COUPONS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const resetSystemCoupons = () => dispatch => {
  dispatch({
    type: RESET_SYSTEM_COUPONS
  });
};

export const getContinuedCoupons = () => async (dispatch, getState) => {

  let pagination = getState().coupons.continuedCoupons.pagination;

  couponOptions.couponStatuses = ['COUPON_PLAYED'];
  couponOptions.startDate = TIME_ALL;
  couponOptions.endDate = new Date().getTime() + CONTINUED_COUPONS_REQUEST_ADDITIONAL_TIME;

  const { continuedCoupons } = getState().coupons;
  if (continuedCoupons.isLoading) return;

  try {
    dispatch({
      type: GET_CONTINUED_COUPONS_REQUEST
    });

    const res = await axios({
      url: '/iddaa/coupons',
      method: 'POST',
      data: {
        ...couponOptions,
        ...pagination
      }
    });

    pagination = {
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex + 1
    };

    dispatch({
      type: GET_CONTINUED_COUPONS_SUCCESS,
      payload: res.data.coupons,
      pagination: pagination
    });

    dispatch(getScoreFromSelections(res.data.coupons));

  } catch (e) {
    dispatch({
      type: GET_CONTINUED_COUPONS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const getWonCoupons = () => async (dispatch, getState) => {
  let pagination = getState().coupons.wonCoupons.pagination;
  let filterName = getState().coupons.activeFilter.filterName;
  const filterDates =  getFilterDates(filterName);

  couponOptions.couponStatuses = ['COUPON_WON'];
  couponOptions.startDate = filterDates.startDate;
  couponOptions.endDate = filterDates.endDate;

  try {
    dispatch({
      type: GET_WON_COUPONS_REQUEST
    });

    const res = await axios({
      url: '/iddaa/coupons',
      method: 'POST',
      data: {
        ...couponOptions,
        ...pagination,
        hideDetails: true
      }
    });

    pagination = {
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex + 1
    };

    dispatch({
      type: GET_WON_COUPONS_SUCCESS,
      payload: res.data.coupons,
      pagination: pagination
    });

  } catch (e) {
    dispatch({
      type: GET_WON_COUPONS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const getRejectedCoupons = () => async (dispatch, getState) => {
  let pagination = getState().coupons.rejectedCoupons.pagination;
  let filterName = getState().coupons.activeFilter.filterName;
  const filterDates =  getFilterDates(filterName);

  couponOptions.couponStatuses = ['COUPON_REJECTED'];
  couponOptions.startDate = filterDates.startDate;
  couponOptions.endDate = filterDates.endDate;

  try {
    dispatch({
      type: GET_REJECTED_COUPONS_REQUEST
    });

    const res = await axios({
      url: '/iddaa/coupons',
      method: 'POST',
      data: {
        ...couponOptions,
        ...pagination
      }
    });

    pagination = {
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex + 1,
    };

    dispatch({
      type: GET_REJECTED_COUPONS_SUCCESS,
      payload: res.data.coupons,
      pagination: pagination
    });

  } catch (e) {
    dispatch({
      type: GET_REJECTED_COUPONS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const getLostCoupons = () => async (dispatch, getState) => {
  let pagination = getState().coupons.lostCoupons.pagination;
  let filterName = getState().coupons.activeFilter.filterName;
  const filterDates =  getFilterDates(filterName);

  couponOptions.couponStatuses = ['COUPON_LOST'];
  couponOptions.startDate = filterDates.startDate;
  couponOptions.endDate = filterDates.endDate;

  try {
    dispatch({
      type: GET_LOST_COUPONS_REQUEST
    });

    const res = await axios({
      url: '/iddaa/coupons',
      method: 'POST',
      data: {
        ...couponOptions,
        ...pagination
      }
    });

    pagination = {
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex + 1
    };

    dispatch({
      type: GET_LOST_COUPONS_SUCCESS,
      payload: res.data.coupons,
      pagination: pagination
    });

  } catch (e) {
    dispatch({
      type: GET_LOST_COUPONS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const getSavedCoupons = () => async (dispatch, getState) => {

  let pagination = getState().coupons.savedCoupons.pagination;
  let filterName = getState().coupons.activeFilter.filterName;
  const filterDates =  getFilterDates(filterName);

  couponOptions.couponStatuses = ['COUPON_SAVED'];
  couponOptions.startDate = TIME_LAST_15_DAYS;
  couponOptions.endDate = filterDates.endDate;

  try {
    dispatch({
      type: GET_SAVED_COUPONS_REQUEST
    });

    const res = await axios({
      url: '/iddaa/coupons',
      method: 'POST',
      data: {
        ...couponOptions,
        ...pagination,
      }
    });

    pagination = {
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex + 1
    };

    dispatch({
      type: GET_SAVED_COUPONS_SUCCESS,
      payload: res.data.coupons,
      pagination: pagination,
    });

    dispatch(getScoreFromSelections(res.data.coupons));

  } catch (e) {
    dispatch({
      type: GET_SAVED_COUPONS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const getTribunCoupons = () => async (dispatch, getState) => {
  let pagination = getState().coupons.tribunCoupons.pagination;
  delete pagination.isLoadMoreButtonVisible;

  couponOptions.couponStatuses = ['COUPON_SAVED'];
  try {
    dispatch({
      type: GET_TRIBUN_COUPONS_REQUEST
    });

    const res = await axios({
      url: '/iddaa/coupons/phenomenons',
      method: 'POST',
      data: {
        ...couponOptions,
        ...pagination
      }
    });

    pagination = {
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex + 1,
      isLoadMoreButtonVisible: true
    };

    dispatch({
      type: GET_TRIBUN_COUPONS_SUCCESS,
      payload: res.data.coupons,
      pagination: pagination
    });

  } catch (e) {
    dispatch({
      type: GET_TRIBUN_COUPONS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const getCouponDetail = couponId => async (dispatch, getState) => {
  const hasStatusEvents = [];
  const unevaluatedEvents = [];
  const hasOfficialScoresEvents = [];
  const unOfficialScoresvents = [];

  let lostCouponsPagination = getState().coupons.lostCoupons.pagination;
  let wonCouponsPagination = getState().coupons.wonCoupons.pagination;

  try {
    dispatch({
      type: GET_COUPON_DETAIL_REQUEST
    });

    const res = await axios({
      url: `/iddaa/coupons/${couponId}`,
      method: 'GET'
    });

    dispatch({
      type: GET_COUPON_DETAIL_SUCCESS,
      payload: res.data,
    });

    dispatch({
      type: GET_LOST_COUPONS_SUCCESS,
      payload: [],
      couponDetail: res.data,
      pagination: lostCouponsPagination
    });

    dispatch({
      type: GET_WON_COUPONS_SUCCESS,
      payload: [],
      couponDetail: res.data,
      pagination: wonCouponsPagination
    });

    dispatch({
      type: GET_OUT_RIGHT_LOST_COUPONS_SUCCESS,
      payload: [],
      couponDetail: res.data
    });

    res.data.couponColumns.forEach(item => {
      if (item.winningStatus === 'UNEVALUATED') {
        unevaluatedEvents.push(item);
      } else {
        hasStatusEvents.push(item);
      }

      if (!item.officialResult) {
        unOfficialScoresvents.push(item);
      } else {
        hasOfficialScoresEvents.push(item);
      }
    });

    if (hasStatusEvents.length) {
      const winningStatus = hasStatusEvents.map( event => {
        return {
          eventId: event.eventId,
          marketId: event.marketId,
          outcomeNo: event.marketOutcomeNo,
          status: event.winningStatus,
          currentScoreDisplay: event.currentScoreDisplay
        };
      });

      dispatch({
        type: GET_EVENT_STATUS_UPDATE_SUCCESS,
        payload: winningStatus
      });
    }

    if (unevaluatedEvents.length) {
      dispatch(getEventStatusUpdate(unevaluatedEvents));
    }

    if (hasOfficialScoresEvents.length) {
      const scores = hasOfficialScoresEvents.map( event => {
        return {
          currentScore: {
            home: event.officialResult?.fullTime?.home,
            away: event.officialResult?.fullTime?.away,
            type: 'FULL_TIME'
          },
          scores: [{
            home: event.officialResult?.halfTime?.home,
            away: event.officialResult?.halfTime?.away,
            type: 'HALF_TIME',
            title: 'İY'
          }],
          overTime: {
            home: event.officialResult?.overTime?.home,
            away: event.officialResult?.overTime?.away,
            type: 'FULL_TIME',
            title: 'Uzt.'
          },
          penalty: {
            home: event.officialResult?.penalty?.home,
            away: event.officialResult?.penalty?.away,
            type: 'FULL_TIME',
            title: 'Pen.'
          },
          sbsEventId: event.eventId,
          matchStatus: 'Played'
        };
      });

      dispatch({
        type: EVENT_SCORES_SUCCESS,
        payload: scores
      });
    }

    if (unOfficialScoresvents.length) {
      dispatch(getEventScores(unOfficialScoresvents));
    }

  } catch (e) {
    dispatch({
      type: GET_COUPON_DETAIL_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getCouponChangeOdds = (couponId, marketId) => async (dispatch, getState) => {

  try {
    dispatch({
      type: GET_COUPON_CHANGE_ODDS_REQUEST
    });

    const res = await axios({
      url: `/iddaa/coupons/changed-odds?couponId=${couponId}&marketId=${marketId}`,
      method: 'GET'
    });

    dispatch({
      type: GET_COUPON_CHANGE_ODDS_SUCCESS,
      payload: res.data,
    });

    return res?.data;

  } catch (e) {
    dispatch({
      type: GET_COUPON_CHANGE_ODDS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const deleteCouponById = couponData => async (dispatch, getState) => {
  try {
    dispatch({
      type: DELETE_COUPON_BY_ID_REQUEST
    });

    dispatch(closeModal('multipleDeleteModal'));
    dispatch(closeModal('singleDeleteModal'));

    const res = await axios({
      url: '/iddaa/cancel',
      method: 'POST',
      data: couponData
    });

    dispatch(resetCouponPagination('CONTINUED'));
    dispatch(resetCouponPagination('OUTRIGHT_CONTINUED'));
    dispatch({
      type: DELETE_COUPON_BY_ID_SUCCESS,
      payload: { ...res.data, toBeCanceledCouponCount: couponData.toBeCanceledCouponCount, couponId: couponData.couponId }
    });

    const { waitingCouponsCount, nonCancelledCouponsCount, cancelledCouponsCount } = res.data;

    if (waitingCouponsCount === 0 && cancelledCouponsCount === 0 && nonCancelledCouponsCount > 0 && couponData.toBeCanceledCouponCount === 0 ) {
      dispatch(openModal('failureDeleteModal'));
    }

    dispatch(updateUserBalance());

    if (nonCancelledCouponsCount === 0 && waitingCouponsCount === 0 && cancelledCouponsCount > 0 && couponData.toBeCanceledCouponCount > 0) {
      dispatch(openModal('allCanceledSuccessModal', { cancelledCouponsCount: cancelledCouponsCount }));
    }

    if ((nonCancelledCouponsCount !== 0 || waitingCouponsCount !== 0) && couponData.toBeCanceledCouponCount > 0) {
      dispatch(openModal('particiallyCancelledCouponModal', {
        balance: getState().auth.data.balance,
        cancelledCouponsCount: cancelledCouponsCount,
        nonCancelledCouponsCount: nonCancelledCouponsCount,
        waitingCouponsCount: waitingCouponsCount
      }));
    }

    dispatch(getContinuedCoupons());
    dispatch(getOutRightContinueCoupons());

  } catch (e) {
    dispatch({
      type: DELETE_COUPON_BY_ID_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });

    if (e.response && e.response.status === 504) {
      dispatch(openModal('couponCancelHoldingModal'));
    }

    dispatch(openModal('failureDeleteModal', { data: errorMessage }));
  }
};

export const deleteSavedCouponById = couponId => async dispatch => {
  try {
    dispatch({
      type: DELETE_SAVED_COUPON_BY_ID_REQUEST
    });

    dispatch(closeModal('deleteSavedCouponModal'));

    const res = await axios({
      url: `/iddaa/coupons/saved?couponId=${couponId}`,
      method: 'DELETE',
    });

    dispatch({
      type: DELETE_SAVED_COUPON_BY_ID_SUCCESS,
      payload: res.data
    });

    dispatch(resetCouponPagination('SAVED'));
    dispatch(resetCouponPagination('OUTRIGHT_SAVED'));
    dispatch(getSavedCoupons({ loadMore: false }));
    dispatch(getOutRightSavedCoupons({ loadMore: false }));

  } catch (e) {
    dispatch({
      type: DELETE_SAVED_COUPON_BY_ID_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getOutRightContinueCoupons = () => async (dispatch, getState) => {
  let pagination = getState().coupons.outRightContinueCoupons.pagination;

  couponOptions.couponStatuses = ['COUPON_PLAYED'];
  couponOptions.startDate = TIME_ALL;
  couponOptions.endDate = new Date().getTime();

  try {
    dispatch({
      type: GET_OUT_RIGHT_CONTINUE_COUPONS_REQUEST
    });

    const res = await axios({
      url: '/iddaa/coupons/outright',
      method: 'POST',
      data: {
        ...couponOptions,
        ...pagination
      }
    });

    pagination = {
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex + 1,
      isLoadMoreButtonVisible: res.data.coupons.length >= 10
    };

    dispatch({
      type: GET_OUT_RIGHT_CONTINUE_COUPONS_SUCCESS,
      payload: res.data.coupons,
      pagination: pagination
    });

    dispatch(getScoreFromSelections(res.data.coupons));

  } catch (e) {
    dispatch({
      type: GET_OUT_RIGHT_CONTINUE_COUPONS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const getOutRightWonCoupons = () => async (dispatch, getState) => {
  let filterName = getState().coupons.activeFilter.filterName;
  const filterDates = getFilterDates(filterName);

  couponOptions.couponStatuses = ['COUPON_WON'];
  couponOptions.startDate = filterDates.startDate;
  couponOptions.endDate = filterDates.endDate;

  try {
    dispatch({
      type: GET_OUT_RIGHT_WON_COUPONS_REQUEST
    });

    const res = await axios({
      url: '/iddaa/coupons/outright',
      method: 'POST',
      data: couponOptions
    });

    dispatch({
      type: GET_OUT_RIGHT_WON_COUPONS_SUCCESS,
      payload: res.data.coupons
    });

  } catch (e) {
    dispatch({
      type: GET_OUT_RIGHT_WON_COUPONS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const getOutRightLostCoupons = options => async (dispatch, getState) => {

  let filterName = getState().coupons.activeFilter.filterName;
  const filterDates = getFilterDates(filterName);

  couponOptions.couponStatuses = ['COUPON_LOST'];
  couponOptions.startDate = filterDates.startDate;
  couponOptions.endDate = filterDates.endDate;

  try {
    dispatch({
      type: GET_OUT_RIGHT_LOST_COUPONS_REQUEST
    });

    const res = await axios({
      url: '/iddaa/coupons/outright',
      method: 'POST',
      data: couponOptions
    });

    dispatch({
      type: GET_OUT_RIGHT_LOST_COUPONS_SUCCESS,
      payload: res.data.coupons
    });

  } catch (e) {
    dispatch({
      type: GET_OUT_RIGHT_LOST_COUPONS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const getOutRightSavedCoupons = ({ loadMore = false }) => async (dispatch, getState) => {
  let pagination = getState().coupons.outRightSavedCoupons.pagination;

  couponOptions.couponStatuses = ['COUPON_SAVED'];
  couponOptions.startDate = TIME_ALL;
  couponOptions.endDate = new Date().getTime();

  if (loadMore) {
    pagination = {
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex + 1,
    };
  }

  try {
    dispatch({
      type: GET_OUT_RIGHT_SAVED_COUPONS_REQUEST
    });

    const res = await axios({
      url: '/iddaa/coupons/outright',
      method: 'POST',
      data: {
        ...couponOptions,
        ...pagination,
      }
    });
    pagination.isLoadMoreButtonVisible = pagination.pageSize < res.data.coupons.length;

    dispatch({
      type: GET_OUT_RIGHT_SAVED_COUPONS_SUCCESS,
      payload: res.data.coupons,
      pagination: pagination
    });

    dispatch(getScoreFromSelections(res.data.coupons));

  } catch (e) {
    dispatch({
      type: GET_OUT_RIGHT_SAVED_COUPONS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const getEventStatusUpdate = couponData => async dispatch => {
  dispatch({ type: GET_EVENT_STATUS_UPDATE_REQUEST });

  const requestData = couponData.map(coupon => {
    if (!coupon.selections) {
      return {
        eventId: coupon.eventId,
        marketId: coupon.marketId,
        outcomeNo: coupon.marketOutcomeNo
      };
    }

    return coupon.selections.map(data => ({
      eventId: data.eventId,
      marketId: data.marketId,
      outcomeNo: data.marketOutcomeNo
    }));
  });

  const marketList = flatten(requestData);
  const uniqMarketList = [...marketList.reduce((m, o) => {
    const key = Object.values(o).join('--');
    return m.has(key) ? m : m.set(key, o);
  }, new Map()).values()];

  const chunkSize = Number(EnvironmentManager.getMessageText({ key: 'winning_losing_request_count' }));
  for (let i = 0; i < uniqMarketList.length; i += chunkSize) {
    const chunk = uniqMarketList.slice(i, i + chunkSize);

    try {
      const marketList = chunk.map(item => `${item.marketId}:${item.outcomeNo}`).join(',');

      const res = await axios.get(`/winning-losing/v3?marketList=${marketList}`);

      const statusMap = new Map(
        res.data.c.map(item => [`${item.mi}:${item.on}`, item.s])
      );

      dispatch({
        type: GET_EVENT_STATUS_UPDATE_SUCCESS,
        payload: chunk.map(event => ({
          ...event,
          status: statusMap.get(`${event.marketId}:${event.outcomeNo}`) || null,
          currentScoreDisplay: null
        }))
      });

    } catch (e) {
      dispatch({
        type: GET_EVENT_STATUS_UPDATE_FAILURE,
        payload: e.response && e.response.data || errorMessage,
      });
    }
  }
};

export const setActiveFilter = filterName => async dispatch => {
  dispatch({
    type: SET_COUPONS_ACTIVE_FILTER,
    payload: filterName
  });
};

export const getScoreFromSelections = coupons => async dispatch => {

  const hasStatusEvents = [];
  const unevaluatedEvents = [];
  const hasOfficialScoresEvents = [];
  const unOfficialScoresvents = { selections: [] };

  coupons?.forEach(coupon => {
    coupon.selections.forEach( selection => {
      if (selection.winningStatus === 'UNEVALUATED') {
        unevaluatedEvents.push(selection);
      } else {
        hasStatusEvents.push(selection);
      }

      if (!selection.officialResult) {
        unOfficialScoresvents.selections.push(selection);
      } else {
        hasOfficialScoresEvents.push(selection);
      }
    });
  });

  if (hasStatusEvents.length) {
    const winningStatus = hasStatusEvents.map(event => {
      return {
        eventId: event.eventId,
        marketId: event?.marketId,
        outcomeNo: event.marketOutcomeNo,
        status: event.winningStatus,
        currentScoreDisplay: event.currentScoreDisplay
      };
    });

    dispatch({
      type: GET_EVENT_STATUS_UPDATE_SUCCESS,
      payload: winningStatus
    });
  }

  if (unevaluatedEvents.length) {
    dispatch(getEventStatusUpdate(unevaluatedEvents));
  }

  if (hasOfficialScoresEvents.length) {
    const scores = hasOfficialScoresEvents.map( event => {
      return {
        currentScore: {
          home: event.officialResult.fullTime.home,
          away: event.officialResult.fullTime.away,
          type: 'FULL_TIME'
        },
        scores: [{
          home: event.officialResult.halfTime?.home,
          away: event.officialResult.halfTime?.away,
          type: 'HALF_TIME',
          title: 'İY'
        }],
        overTime: {
          home: event.officialResult?.overTime?.home,
          away: event.officialResult?.overTime?.away,
          type: 'FULL_TIME',
          title: 'Uzt.'
        },
        penalty: {
          home: event.officialResult?.penalty?.home,
          away: event.officialResult?.penalty?.away,
          type: 'FULL_TIME',
          title: 'Pen.'
        },
        sbsEventId: event.eventId,
        matchStatus: 'Played'
      };
    });
    dispatch({
      type: EVENT_SCORES_SUCCESS,
      payload: scores
    });
  }

  if (unOfficialScoresvents.selections.length) {
    dispatch(getEventScores([unOfficialScoresvents]));
  }
};

export const getIddaaCouponInfo = (generalId, modalName) => async dispatch => {
  try {

    dispatch({
      type: GET_IDDAA_COUPON_INFO_REQUEST
    });

    const res = await axios.get('/iddaa/coupons?couponIds=' + generalId);

    dispatch({
      type: GET_IDDAA_COUPON_INFO_SUCCESS,
      payload: res.data.coupons[0],
    });

    dispatch(openModal(modalName));
  } catch (e) {
    dispatch({
      type: GET_IDDAA_COUPON_INFO_FAILURE,
      payload: e.response && e.response.data
    });
  }
};

export const getTJKCouponInfo = (generalId, modalName) => async dispatch => {
  try {

    dispatch({
      type: GET_TJK_COUPON_INFO_REQUEST
    });
    const res = await axios.get('/mobile/tjk/coupon/customer/by-couponIds?couponIds=' + generalId);
    dispatch({
      type: GET_TJK_COUPON_INFO_SUCCESS,
      payload: res.data.body.coupons[0],
    });

    dispatch(openModal(modalName));
  } catch (e) {
    dispatch({
      type: GET_TJK_COUPON_INFO_FAILURE,
      payload: e.response && e.response.data
    });
  }
};
